import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter, Input, Button } from 'reactstrap';
import QrReader from 'react-qr-reader';

export default class ModalConfirmation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invalid: true,
      data: {
        observacao: ""
      }
    };
  }

  onConfirm = e => {
    e.preventDefault();

    this.props.onConfirm(this.state.data);
  };

  handleData = (key, value) => {
    this.setState(state => ({
      data: {
        ...state.data,
        [key]: value
      }
    }));
  };

  handleScan = value => {
    if (value) {
      try {
        let { valid, data, ...otherProps } = JSON.parse(atob(value));
        if (valid) {
          this.setState(state => ({
            invalid: false,
            data: {
              ...state.data,
              ...otherProps,
              qrcode: data
            }
          }));
        }
      } catch (e) {
        this.setState(({ data }) => ({
          invalid: true,
          data: {
            ...data,
            qrcode: 'dri0+fGc+hq4I8gYSufaRChZvOggZlryTusXOYytO9JpINQ+WiokDuz07yJzX1vtxpPls9ui+Jgz3QIS5Zkopw=='
          }
        }));
      }
    }
  };

  handleError = err => {
    this.setState(({ data }) => ({
      invalid: true,
      data: {
        ...data,
        qrcode: err
      }
    }));
  };

  changeObservacao = e => {
    this.handleData("observacao", e.target.value.replace(/^\s+|\s+(?=\s$|\s)/g, ''));
  }

  handleToggle = () => {
    this.setState({
      invalid: true,
      data: {
        observacao: ""
      }
    });

    this.props.toggle();
  };

  render () {
    const { onConfirm, ...otherProps } = this.props;

    const { invalid, data: { observacao, qrcode } } = this.state;

    return (<Modal {...otherProps} toggle={this.handleToggle} keyboard autoFocus>
      <form onSubmit={this.onConfirm}>
        <ModalBody>
          <QrReader delay={500}
          onError={this.handleError}
          onScan={this.handleScan} />
          <Input placeholder="Observações..." value={observacao} onChange={this.changeObservacao} type="textarea" />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between align-items-center">
          <Button color="danger" onClick={this.handleToggle}>Fecha</Button>
          {(!qrcode || !invalid) && <Button disabled={!qrcode} color="success" type="submit">Confirma</Button>}
        </ModalFooter>
      </form>
    </Modal>);
  }
}


// WEBPACK FOOTER //
// ./src/modules/agenda/ModalConfirmation.js